var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Line_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.952 19.573c-.225.17-.464.348-.667.525h1.717a.75.75 0 1 1 0 1.5h-3a.75.75 0 0 1-.75-.75c0-1.125.957-1.842 1.8-2.475.563-.422 1.2-.9 1.2-1.275a.75.75 0 1 0-1.5 0 .75.75 0 1 1-1.5 0 2.25 2.25 0 0 1 4.5 0c0 1.125-.956 1.842-1.8 2.475Zm6.3-4.725a.75.75 0 0 0-.75.75v2.25h-.75a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 1 0-1.5 0v1.5a2.25 2.25 0 0 0 2.25 2.25h.75v1.5a.75.75 0 1 0 1.5 0v-5.25a.75.75 0 0 0-.75-.75Zm-7.5-2.25v-3.75a.75.75 0 1 0-1.5 0v3h-2.25a.75.75 0 1 0 0 1.5h3a.75.75 0 0 0 .75-.75Zm7.5-7.5a.75.75 0 0 0-.75.75v1.78A9 9 0 1 0 8.73 20.984a.76.76 0 0 0 .753-.121.75.75 0 0 0-.207-1.277A7.5 7.5 0 1 1 18.48 8.848h-1.977a.75.75 0 1 0 0 1.5h2.25c.597 0 1.609.202 2.03-.22.423-.422.22-1.433.22-2.03v-2.25a.75.75 0 0 0-.75-.75Z",
    fill: "#123862"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Line_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3 3.6)",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgLine;